// yarn ng build --aot --env=web --base-href=/app/

export const environment = {
	production: true,
	apiUrl: '',
	webUrl: '/',
	webBuild: true,
	expoBuild: false
};



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/environments/environment.ts